import { isToastActive, showToast, type ToastifyId, updateToast } from '@lokalise/louis';

import type { BgProcessFinishedPayload, BgProcessUpdatedPayload } from '@app/sockets/socketTypes';

import getEditorLink from '../../../../utils/location';
import ActivityDescription, { getProgress } from '../../components/ActivityDescription';
import ActivityDoneDescription, { Link } from '../../components/ActivityDoneDescription';

export interface Handler {
    onProgress(
        payload: Pick<BgProcessUpdatedPayload, 'bulk' | 'progress'>,
        toastId: ToastifyId,
        initial?: boolean,
    ): void;
    onFinished(payload: BgProcessFinishedPayload, isOnProjectPage: boolean): void;
    onEarlyFinish(payload: BgProcessFinishedPayload): void;
}

export const defaultUpdateAction = (
    toastId: ToastifyId,
    title: string,
    progressRaw: string,
    keyCount: number,
    initial = false,
) => {
    const progress = parseFloat(progressRaw) / 100;
    const done = getProgress(keyCount, progress);
    const activityDescription = `Completed ${done} of ${keyCount} keys`;

    if (isToastActive(toastId)) {
        updateToast(toastId, {
            title,
            description: <ActivityDescription progress={progress} description={activityDescription} />,
        });
    } else if (initial) {
        showToast({
            type: 'info',
            autoClose: false,
            toastId,
            title,
            description: <ActivityDescription progress={progress} description={activityDescription} />,
        });
    }
};

export const defaultFinishedAction = (
    isOnEditorPage: boolean,
    title: string,
    projectId: string,
    branchName?: string,
    additionalMessage = '',
) => {
    const description = isOnEditorPage ? (
        <ActivityDoneDescription>
            {additionalMessage}
            {projectId ? <Link href={getEditorLink(projectId, branchName)}>Reload editor</Link> : 'Reload editor'} to
            see the changes
        </ActivityDoneDescription>
    ) : (
        <ActivityDoneDescription>
            {additionalMessage}
            {projectId ? (
                <Link href={getEditorLink(projectId, branchName)}>Open the project’s editor</Link>
            ) : (
                'Open the project’s editor'
            )}{' '}
            to see the changes
        </ActivityDoneDescription>
    );

    showToast({
        type: 'warning',
        title,
        autoClose: false,
        description,
    });
};
